import React from 'react';

function TodosError() {
  return <p>Desespérate, hubo un error...</p>;
}

export { TodosError };